<template>
  <section class="px-4 py-12 md:py-16 bg-neutral-700">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.whyNow.title') }}</h2>
      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">{{ t('landing.whyNow.body') }}</p>

      <div class="w-full mt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="side in SIDES"
          :key="side"
          class="p-6 rounded-2xl bg-neutral-800 text-left flex flex-col gap-2"
          :class="side === 'soundz' ? 'ring-1 ring-primary' : ''"
        >
          <span class="text-xs text-neutral-400 uppercase tracking-wide">
            {{ t(`landing.whyNow.${side}.label`) }}
          </span>
          <h3 class="mt-0 mb-0">{{ t(`landing.whyNow.${side}.title`) }}</h3>
          <p class="text-neutral-300 mt-0 mb-0">{{ t(`landing.whyNow.${side}.text`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const SIDES = ['others', 'soundz'] as const
</script>
